<script>
    import pattern_4 from "../../../public/src/svg/Patterns/pattern_4.svelte";
    import pattern_5 from "../../../public/src/svg/Patterns/pattern_5.svelte";
</script>

<div class="footer">
    <a href="/" class="footer-logo">
        <img class="logo-svg" src="/src/Logo_mini.svg" alt="" />
    </a>
    <div class="space"></div>
    <div class="links">
        <a href="https://vk.com/phygital_tyumen" target="_blank">
            <svg
                width="51"
                height="33"
                viewBox="0 0 51 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                    d="M27.8498 32.4896C10.8355 32.4896 1.13092 20.6098 0.726562 0.841797H9.24924C9.52917 15.351 15.8122 21.4967 20.789 22.7639V0.841797H28.8142V13.3551C33.7287 12.8166 38.8915 7.11433 40.6334 0.841797H48.6587C47.3211 8.57159 41.7223 14.2738 37.7409 16.6181C41.7223 18.5189 48.0991 23.4926 50.5252 32.4896H41.6912C39.7939 26.4705 35.0663 21.8136 28.8142 21.18V32.4896H27.8498Z"
                    fill="currentColor"
                ></path></svg
            >
            <h3>phygital_tyumen</h3>
        </a>
        <div class="pattern-block flex end">
            <div class="pattern desktop">
                <svelte:component this={pattern_4} />
            </div>
            <div class="pattern mobile">
                <svelte:component this={pattern_5} />
            </div>
            <a class="mail" href="mailto:phygital72@yandex.ru">
                <h3>phygital72@yandex.ru</h3>
            </a>
        </div>
    </div>
</div>

<style lang="less" global>
    @import "Footer.less";
</style>
